import styled from "styled-components";

// Base styled components (referenced elsewhere via styled(DetailTable) or ${DetailTh} etc.)
const DetailTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  font-size: 14px;
  border: 1px solid #ccc;
  table-layout: fixed;
`;

const DetailCaption = styled.caption`
  background: #999;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  padding: 2px 5px;
`;

const DetailTh = styled.th`
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  padding: 8px;
  text-align: right;
  font-weight: bold;
  width: 120px;
  vertical-align: top;
`;

const DetailTd = styled.td`
  border: 1px solid #ccc;
  padding: 8px;
  background-color: #fff;
  vertical-align: middle;
`;

const OrderedDetailStyles = {
  FlexRow: styled.div`
    display: flex;
    flex-direction: row;
    gap: 0;
  `,

  FlexBetween: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0;
  `,
  // メインコンテナ
  DetailContainer: styled.div`
    margin-bottom: 20px;
  `,

  DetailTitle: styled.h2`
    background: url(/images/window_title.png) no-repeat 0 50%;
    padding: 5px 0 0 35px;
    color: #333;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 10px;
  `,
  PartsTitle: styled.h3`
    padding: 5px 0 0 5px;
    color: #333;
    font-size: 20px;
    line-height: 30px;
    margin: 30px 0 0;
    font-weight: bold;
    border-left: 5px solid #f33;
  `,

  // 見積詳細セクション
  OrderDetail: styled.div`
    margin-bottom: 20px;
  `,

  // 見積詳細内のdiv
  OrderDetailDiv: styled.div`
    background-color: #ffa;
    border: 1px solid #f93;
    border-radius: 5px;
    color: #333;
    line-height: 33px;
    padding: 0 5px;
    clear: right;
    overflow: hidden;
  `,

  // 見積詳細内のdt
  OrderDetailDt: styled.dt`
    float: left;
    font-weight: bold;
    padding-right: 5px;
    font-size: 18px;
  `,

  // 見積詳細内のdt.order
  OrderDetailDtOrder: styled.dt`
    float: left;
    font-weight: bold;
    padding-right: 5px;
    font-size: 18px;
    clear: both;
  `,

  // 見積詳細内のdd
  OrderDetailDd: styled.dd`
    color: #00f;
    float: left;
    padding-right: 15px;
    font-size: 18px;
  `,
  // 写真表示用のスタイル
  PhotoSection: styled.div`
    margin-top: 20px;
  `,

  DetailTd: styled.td`
    padding: 10px;
    text-align: center;
    vertical-align: middle;
  `,
  // 重要ボタン
  ImportantBtn: styled.a`
    display: inline-block;
    background: #ff3333 url(/images/arrow_important.png) no-repeat 10px 50%;
    color: #fff;
    height: 33px;
    border-style: solid;
    border-width: 1px;
    border-color: #ffe4e4 #ac1d1f #ac1d1f #ffe4e4;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px 0 30px;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      background: #e52e2e;
    }
  `,

  // 重要ボタン2
  ImportantBtn2: styled.a`
    display: inline-block;
    background: #3366ff url(/images/arrow_important.png) no-repeat 10px 50%;
    color: #fff;
    height: 33px;
    border-style: solid;
    border-width: 1px;
    border-color: #99ccff #1c3dc0 #1c3dc0 #99ccff;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px 0 30px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #1c3dc0;
    }
  `,

  // グレーボタン
  BtnGray: styled.a`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border-style: solid;
    border-width: 1px;
    border-color: #eee #999 #999 #eee;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #ccc;
    }
  `,

  // 詳細セクション
  DetailSection: styled.div`
    margin: 15px auto 0;
    width: 100%;
    clear: both;
  `,

  // ルームセラー
  RoomSeller: styled.div`
    border-style: solid;
    border-width: 1px;
    border-color: #ff3333;
    background: #ffe4e4;
    padding: 20px;
  `,

  // 依頼情報
  RequestInfo: styled.div`
    margin-bottom: 20px;
  `,

  // 部品情報
  PartsInfo: styled.div`
    margin-bottom: 20px;
  `,

  // 社内用備考情報テーブル
  RemarkNoteTable: styled.table`
    margin: 15px 0;
    margin-top: 15px; // 上書き

    clear: both;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #333;
  `,

  // 注文情報テーブル
  OrderInfoTable: styled.table`
    margin: 15px 0;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #333;
    border-collapse: collapse;
    border-spacing: 0;
  `,

  // 注文情報テーブルの右寄せ
  OrderInfoRight: styled.th`
    text-align: right;
    padding-right: 5px;
    border: 1px solid #333;
    padding: 8px 2px;
  `,

  // 注文情報テーブルのノート
  OrderInfoNote: styled.td`
    text-align: left;
    padding-left: 5px;
    border: 1px solid #333;
    padding: 8px 2px;
  `,

  // テキストエリア
  TextArea: styled.textarea`
    width: 96%;
    height: 4em;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 5px;
    font-family: inherit;
    font-size: 14px;
    resize: vertical;
  `,

  // フォント要素（span要素に変更）
  FontElement: styled.span`
    color: #008000;
    font-size: 18px;
    text-decoration: underline;
  `,

  // フォント要素（理由）
  FontElementReason: styled.span`
    color: #008000;
  `,

  // 小さいフォント
  SmallFont: styled.span`
    font-size: 9pt;
  `,

  // 注文完了
  OrderComplete: styled.div`
    margin: 10px 0;
    text-align: center;
  `,

  // モーダルコンテンツ
  ModalContent: styled.div`
    position: fixed;
    display: none;
    z-index: 2;
    margin: 0;
    padding: 10px 20px;
    border: 5px solid #ccc;
    background: #fff;
  `,

  // 詳細テーブル（requestinfo.ctpのtable.detailに対応）
  DetailTable: DetailTable,

  // テーブルキャプション（requestinfo.ctpのcaptionに対応）
  DetailCaption: DetailCaption,

  // テーブルヘッダー（requestinfo.ctpのthに対応）
  DetailTh: DetailTh,

  // テーブルセル（requestinfo.ctpのtdに対応）
  DetailTd: DetailTd,

  // ハイライトされたテーブルセル（発送先用）
  DetailTdHighlight: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #ffff99;
    font-weight: bold;
    font-size: 15px;
    vertical-align: top;
  `,

  // 左寄せテーブルセル（requestinfo.ctpのtd.leftに対応）
  DetailTdLeft: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    text-align: left;
    vertical-align: top;
  `,

  // 警告テキスト（requestinfo.ctpのfont color="#ff0000"に対応）
  WarningText: styled.div`
    color: #ff0000;
    font-size: 14px;
    margin: 10px 0;
    line-height: 1.4;
  `,

  // 注意テキスト（requestinfo.ctpのfont style="font-size:10pt; color:#FFFF00;"に対応）
  NoticeText: styled.span`
    font-size: 10pt;
    color: #ffff00;
    margin-left: 10px;
  `,

  // 赤文字テキスト（requestinfo.ctpのspan style="font-size:16px; font-weight: bold; color: #ff0000;"に対応）
  RedText: styled.span`
    font-size: 16px;
    font-weight: bold;
    color: #ff0000;
  `,

  // 写真セクション
  PhotoSection: styled.div`
    margin-top: 20px;
  `,

  // 発注元テーブル用のスタイル（条件付き表示用）
  OrdererTable: styled(DetailTable)`
    margin-bottom: 15px;
  `,

  // 発送先テーブル用のスタイル（条件付き表示用）
  DeliveryTable: styled(DetailTable)`
    margin-bottom: 15px;
  `,

  // 見積回答期限テーブル用のスタイル
  DeadlineTable: styled(DetailTable)`
    margin-bottom: 15px;
  `,

  // 修理対象車輌情報テーブル用のスタイル
  RepairTargetTable: styled(DetailTable)`
    margin-bottom: 15px;
  `,

  // 備考テーブル用のスタイル
  RemarksTable: styled(DetailTable)`
    margin-bottom: 15px;
  `,

  // 写真テーブル用のスタイル
  PhotoTable: styled(DetailTable)`
    margin-bottom: 15px;
  `,

  // 車輌情報テーブル用のスタイル
  VehicleInfoTable: styled(DetailTable)`
    margin-bottom: 15px;
  `,

  // 行のスタイル（複数列対応）
  DetailRow: styled.tr`
    &:nth-child(even) {
      background-color: #f9f9f9;
    }

    &:hover {
      background-color: #f0f8ff;
    }
  `,

  // セルの結合用スタイル
  DetailTdColspan: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: top;
    ${(props) => props.colspan && `grid-column: span ${props.colspan};`}
  `,

  // レスポンシブ対応用のスタイル
  ResponsiveTable: styled(DetailTable)`
    @media (max-width: 768px) {
      font-size: 12px;

      ${DetailTh}, ${DetailTd} {
        padding: 4px;
        font-size: 12px;
      }

      ${DetailCaption} {
        font-size: 14px;
        padding: 8px;
      }
    }
  `,

  // 印刷用スタイル
  PrintStyles: styled.div`
    @media print {
      ${DetailTable} {
        border: 1px solid #000;
        page-break-inside: avoid;
      }

      ${DetailTh}, ${DetailTd} {
        border: 1px solid #000;
        background-color: #fff !important;
      }

      ${DetailCaption} {
        background-color: #f0f0f0 !important;
        border: 1px solid #000;
      }
    }
  `,

  // 部品情報テーブル（partslist.ctp用）
  PartsInfoTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    border: 1px solid #ccc;
    color: #333;
    margin: 15px 0;
  `,

  // 部品情報テーブルのヘッダー行
  PartsInfoHeader: styled.th`
    background-color: #ffbcbc;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    color: #333;
    vertical-align: middle;
    border: 1px solid #333;
  `,

  PartsHeaderRow: styled.tr`
    background: #ff3333;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
  `,
  // 部品情報テーブルのセル
  PartsInfoCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: top;
    text-align: center;
  `,

  // 部品名ヘッダー（特殊なスタイル）
  PartsNameHeader: styled.th`
    background: #ff3333;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
  `,

  // 他社成約ヘッダー
  OtherCompanyHeader: styled.th`
    background-color: #696969;
    color: #fff;
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    vertical-align: middle;
    width: 50px;
  `,

  AnswerHeader: styled.th`
    background: #ff3333;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 2px 5px;
    border: 1px solid #333;
    width: 50px;
  `,

  AnswerHeaderRow: styled.tr`
    background-color: #f0f8ff;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
  `,

  AnswerRow: styled.tr`
    background: #fff;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 2px 5px;
    border: 1px solid #333;
    width: 50px;
  `,

  AnswerRowCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background: #fff;
    vertical-align: top;
    text-align: center;
  `,
  AnswerCell: styled.td`
    border: 1px solid #ccc;
    padding: 5px;
    background: #fff;
    vertical-align: top;
    text-align: left !important;
  `,

  // 部品カテゴリアイコン
  PartsCategoryIcon: styled.span`
    display: inline-block;
    padding: 2px 6px;
    margin: 2px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: bold;
    color: #fff;

    &.icon_r {
      background-color: #ff0000;
    }

    &.icon_rb {
      background-color: #8b0000;
    }

    &.icon_g {
      background-color: #008000;
    }

    &.icon_e {
      background-color: #0000ff;
    }

    &.icon_y {
      background-color: #ffa500;
    }
  `,

  // 必須マーク
  RequiredMark: styled.img`
    width: 12px;
    height: 12px;
    margin-left: 3px;
    vertical-align: middle;
  `,

  // 入力フィールド
  PartsInput: styled.input`
    width: 100%;
    max-width: 150px;
    padding: 4px;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 14px;
  `,

  // セレクトボックス
  PartsSelect: styled.select`
    width: 100%;
    max-width: 150px;
    padding: 4px;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 14px;
  `,

  // テキストエリア（部品備考用）
  PartsTextarea: styled.textarea`
    width: 95%;
    height: 60px;
    padding: 4px;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 14px;
    resize: vertical;
  `,

  // 自社管理番号セル
  CompanyCodeCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fdf5e6;
    vertical-align: top;
    text-align: center;
  `,

  // 部品備考セル
  PartsRemarkCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: top;
    text-align: left;
  `,

  // アクションボタン
  PartsActionButton: styled.a`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border: 1px solid #999;
    border-radius: 3px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    text-decoration: none;
    margin: 2px;

    &:hover {
      background: #ccc;
    }
  `,

  // 質問ボタン
  QuestionButton: styled.a`
    vertical-align: middle;
    margin-top: -5px;
    display: inline-block;
    background: #3366ff url(/images/arrow_important.png) no-repeat 10px 50%;
    color: #fff;
    height: 33px;
    border-style: solid;
    border-width: 1px;
    border-color: #99ccff #1c3dc0 #1c3dc0 #99ccff;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px 0 30px;
    cursor: pointer;

    &:hover {
      background: #1c3dc0;
    }
  `,

  // 入庫済み車輌ボタン
  StockedVehicleButton: styled.a`
    display: inline-block;
    background: #ff3333;
    color: #fff;
    height: 28px;
    border: 1px solid #ac1d1f;
    border-radius: 3px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    text-decoration: none;
    margin: 2px;

    &:hover {
      background: #e52e2e;
    }
  `,

  // 損保依頼分の警告テキスト
  InsuranceWarning: styled.div`
    color: #ff0000;
    font-size: 12pt;
    font-weight: bold;
    margin: 10px 0;
  `,

  // 写真・ファイルアイコン
  FileIcon: styled.img`
    width: 30px;
    height: 20px;
    cursor: pointer;
    margin: 0 2px;
    vertical-align: middle;
  `,

  // ラジオボタンラベル
  RadioLabel: styled.label`
    display: inline-block;
    margin: 0 5px;
    font-size: 14px;
    cursor: pointer;
  `,

  // 追加ボタン
  AddButton: styled.input`
    background: #4caf50;
    color: white;
    border: none;
    padding: 4px 8px;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;

    &:hover {
      background: #45a049;
    }
  `,

  // 部品備考追加セレクト
  RemarkSelect: styled.select`
    width: 120px;
    padding: 2px;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 12px;
    margin-right: 5px;
  `,

  // 現車紐付き行のスタイル
  GenshaRow: styled.tr`
    background-color: #f0f8ff;

    &:hover {
      background-color: #e6f3ff;
    }
  `,

  // 追加商品情報入力セクション（addpartslist.ctp用）
  AddPartsSection: styled.div`
    margin: 20px 0;
  `,

  // 追加商品情報入力テーブル
  AddPartsTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    font-size: 14px;
    border: 1px solid #ccc;
  `,

  // 追加商品情報入力のヘッダー
  AddPartsHeader: styled.th`
    background-color: #ffbcbc;
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    color: #333;
    vertical-align: middle;
  `,

  // 追加商品情報入力のセル
  AddPartsCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: top;
    text-align: center;
  `,

  // 追加商品名ヘッダー
  AddPartsNameHeader: styled.th`
    background-color: #696969;
    color: #fff;
    border: 1px solid #ccc;
    padding: 10px;
    text-align: left;
    font-weight: bold;
    vertical-align: top;
  `,

  // カテゴリ選択テーブル
  CategorySelectTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 15px;
    font-size: 14px;
    border: 1px solid #ccc;
  `,

  // カテゴリ選択ヘッダー
  CategorySelectHeader: styled.th`
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    color: #333;
    vertical-align: middle;
  `,

  // カテゴリ選択セル
  CategorySelectCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: middle;
    text-align: center;
  `,

  // ステップ表示
  StepText: styled.span`
    font-weight: bold;
    color: #333;
  `,

  // 矢印表示
  ArrowText: styled.span`
    font-weight: bold;
    color: #666;
    font-size: 16px;
  `,

  // 登録ボタン
  RegisterButton: styled.a`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border: 1px solid #999;
    border-radius: 3px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #ccc;
    }
  `,

  // 開閉ボタン
  ToggleButton: styled.a`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border-style: solid;
    border-width: 1px;
    border-color: #eee #999 #999 #eee;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;

    &:hover {
      background: #ccc;
    }
  `,

  // 取消ボタン
  CancelButton: styled.a`
    display: inline-block;
    background: #333;
    color: #fff;
    height: 24px;
    border: 1px solid #000;
    border-radius: 3px;
    text-align: center;
    line-height: 24px;
    font-size: 12px;
    padding: 0 8px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #555;
    }
  `,

  // 追加商品情報入力エリア
  AddPartsArea: styled.div`
    display: block;
    padding: 5px;
    border: #f30 1px solid;
    margin-top: 15px;
  `,

  // 品名入力フィールド
  PartsNameInput: styled.input`
    width: 20em;
    padding: 4px;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 14px;
    margin-left: 10px;
  `,

  // 追加商品備考セル
  AddPartsRemarkCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: top;
    text-align: left;
  `,

  // 追加商品自社管理番号セル
  AddCompanyCodeCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fdf5e6;
    vertical-align: top;
    text-align: center;
  `,

  // 追加商品取消セル
  AddCancelCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: top;
    text-align: center;
  `,

  // Assy品注意事項ボックス
  AssyNoticeBox: styled.div`
    background-color: #ffff00;
    font-size: 15px;
    width: 1200px;
    text-align: left;
    padding: 15px 0;
    margin: 0 auto;
    line-height: 1.6;
  `,

  // Assy品注意事項コンテナ
  AssyNoticeContainer: styled.div`
    text-align: center;
    margin: 20px 0;
  `,

  // 部品確認テーブル（partsconfirm.ctp用）
  PartsConfirmTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    font-size: 14px;
    border: 1px solid #ccc;
    color: #333;
  `,

  // 部品名ヘッダー（現車紐付きの場合）
  PartsNameHeaderGensha: styled.th`
    background: #ffd700;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
  `,

  // 部品名ヘッダー（通常）
  PartsNameHeaderNormal: styled.th`
    background: #ff3333;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
  `,

  // テーブルヘッダー
  ConfirmTableHeader: styled.th`
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    color: #333;
    vertical-align: middle;
  `,

  // テーブルセル
  ConfirmTableCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: top;
    text-align: center;
  `,

  // 在庫なし回答行（nonegrクラス）
  NonegrRow: styled.tr`
    background-color: #d3d3d3;

    td {
      background-color: #d3d3d3;
    }
  `,

  // 未回答行（noneクラス）
  NoneRow: styled.tr`
    background-color: #c0c0c0;

    td {
      background-color: #c0c0c0;
    }
  `,

  // 自社管理番号セル（背景色#FDF5E6）
  CompanyCodeCellBg: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fdf5e6;
    vertical-align: top;
    text-align: center;
  `,

  // 送料ヘッダー（税別、背景色#FFF666）
  DeliveryHeaderTaxEx: styled.th`
    background-color: #fff666;
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    color: #333;
    vertical-align: middle;
  `,
};

export default OrderedDetailStyles;
